type MeshSize = (typeof MESH_SIZES)[keyof typeof MESH_SIZES];
type OdMapType = (typeof OD_MAP_TYPES)[keyof typeof OD_MAP_TYPES];

const MESH_SIZES = {
  M125: '125m',
  M1000: '1km',
} as const satisfies Record<string, string>;

// ODマップの表示種別
const OD_MAP_TYPES = {
  MESH_125M: 'mesh_125m',
  MESH_1KM: 'mesh_1km',
  CITY: 'city',
  TOWN: 'town',
} as const satisfies Record<string, string>;

export type { MeshSize, OdMapType };
export { MESH_SIZES, OD_MAP_TYPES };
